import {
    EzString
} from '/ezlibrary/helpers/EzHelpers.js';

import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

/**
 * @class
 * @extends {EzEnumeration2}
 * @description
 * A template for an ezClocker enumeration class.
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * The following public static methods provided by the EzEnumeration2 parent class:
 *      EzExportAction.ezAsEnum(enumPropertyNameOrValue)
 *      EzExportAction.ezValueOf(enumPropertyName)
 *      EzExportAction.ezNameOf(enumPropertyValue)
 *      EzExportAction.ezEnumData(enumPropertyValue)
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into non-enumeration classes with:
 *      import {
 *          // ... other enumeration classes ...
 *          EzAccrualType
 *      } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into other enumeration classes or classes that cannot import EzEnumerations:
 *      import { EzAccrualType } from '/ezlibrary/enums/EzAccrualType.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Static access to methods, fields, and properties only!
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzAccrualType extends EzEnumeration2 {
    /**
     * @static
     * @public @method
     * Example static method that returns the enumeration property's data.display value.
     * If the enumPropertyValue is not a valid enumeration property value, then EzEnumTemplate.UNKNOWN.display is returned.
     * @param {undefined|null|string} enumPropertyValue
     * A valid enumeration property value from EzEnumTemplate
     * @returns {string}
     */
    static ezToDisplayName(enumPropertyValue) {
        return EzString.stringOrEmpty(
            EzString.hasLength(enumPropertyValue)
                ? EzAccrualType.ezEnumData(enumPropertyValue)?.display
                : EzAccrualType.ezEnumData(EzAccrualType.UNKNOWN)?.display);
    }

    /*
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * Initialization Section: ONLY PLACE INITIALIZATION CODE BEYOND THIS SECTION
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     */

    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     * @type {EzAccrualType}
     * Internal static instance of the EzAccrualType
     */
    static #ezEnumTemplateSingleton = null;

    /**
     * @static
     * @private @method
     * Builds the enumeration properties and values for EzAccrualType
     */
    static #ezBuildEnumeration() {
        this.#ezEnumTemplateSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'UNKNOWN',
            // Enumeration Property Value
            'UNKNOWN',
            // Optional Enumeration Data Value
            {
                value: 'UNKNOWN',
                display: 'Unknown Accrual Type'
            });

        this.#ezEnumTemplateSingleton.ezBuildEnumProp(
            'MANUAL',
            'MANUAL',
            {
                value: 'MANUAL',
                display: 'Manual Accrual'
            });

        this.#ezEnumTemplateSingleton.ezBuildEnumProp(
            'YEARLY',
            'YEARLY',
            {
                value: 'YEARLY',
                display: 'Yearly Accrual'
            });

        this.#ezEnumTemplateSingleton.ezBuildEnumProp(
            'PAY_PERIOD',
            'PAY_PERIOD',
            {
                value: 'PAY_PERIOD',
                display: 'Pay Period Accrual'
            });

        this.#ezEnumTemplateSingleton.ezBuildEnumProp(
            'HOURS_WORKED',
            'HOURS_WORKED',
            {
                value: 'HOURS_WORKED',
                display: 'Hours Worked Accrual'
            });
    }

    /**
     * Static Initialization of EzExportAction
     */
    static {
        if (null == this.#ezEnumTemplateSingleton) {
            this.#ezEnumTemplateSingleton = new EzAccrualType();

            globalThis.window.EzIntegrationMappingViewType = this.#ezEnumTemplateSingleton;

            this.#ezBuildEnumeration();
        }
    }

    /*
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * End of Initialziation Section: !! DO NOT PLACE ANY CODE BEYOND THIS SECTION !!
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     */
 }
